var exports = {
  "s": "deletedCommentAuthorLink__RJN3Il",
};

module.exports = exports;
